export default {
  forgotPasswordTempUser: {
    email: "",
    userId: 0,
  },
};
